module.exports = __webpack_public_path__ + "img/offResult.4f097404.png";